// @flow

import { JSableOmitPrivate } from 'jsable';
import ko from 'rgs-knockout';
import type { Observable, PureComputed } from 'rgs-knockout';

export interface IAddressElement {
	clear: ()=>void
}

class AddressBase extends JSableOmitPrivate {
	Name: Observable<string> = ko.observable().extend({ toFromJS: true });
	Kladr: Observable<string> = ko.observable().extend({ toFromJS: true });
	PostCode: Observable<string> = ko.observable().extend({ toFromJS: true });

	clear () {
		this.Name(null);
		this.Kladr(null);
		this.PostCode(null);
	}
}

export class AddressSettlement extends AddressBase implements IAddressElement {
	RegionID: Observable<number> = ko.observable().extend({ toFromJS: true });
	AreaName: Observable<string> = ko.observable().extend({ toFromJS: true });
	CityName: Observable<string> = ko.observable().extend({ toFromJS: true });

	HasStreets: Observable<?boolean> = ko.observable().extend({ toFromJS: true });
	HasHouses: Observable<?boolean> = ko.observable().extend({ toFromJS: true });

	clear () {
		super.clear();
		this.RegionID(null);
		this.AreaName(null);
		this.CityName(null);
		this.HasStreets(null);
		this.HasHouses(null);
	}
}

export class AddressStreet extends AddressBase implements IAddressElement {
	HasHouses: Observable<?boolean> = ko.observable().extend({ toFromJS: true });

	clear () {
		super.clear();
		this.HasHouses(null);
	}
}

export class AddressHouse extends AddressBase implements IAddressElement {
	clear () {
		super.clear();
	}
}

export class Address extends JSableOmitPrivate {
	Kladr: PureComputed<string>;
	Apartment: Observable<string> = ko.observable().extend({ toFromJS: true });
	HasStreets: Observable<boolean> = ko.observable(true).extend({ toFromJS: true });
	Settlement: AddressSettlement = new AddressSettlement();
	Street: AddressStreet = new AddressStreet();
	House: AddressHouse = new AddressHouse();

	constructor () {
		super();
		this.Kladr = ko.pureComputed(() => {
			return this.House.Kladr() || this.Street.Kladr() || this.Settlement.Kladr();
		}).extend({ toFromJS: true });
	}
}
